import { Tag } from 'antd'
import React, { useEffect } from 'react'
import Input from '../../components/UI/Input'
import { IConfigPageProps } from './types'
import { Divider, Input as AntdInput } from 'antd';
import SwitchInput from '../../components/UI/SwitchInput';
import {sendSystemLog, useAuth} from "../../context/AuthProvider/useAuth";
const { TextArea } = AntdInput;


function POSDrawer(props: IConfigPageProps) {
  const {canEdit} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'system configs',
    object_name: 'pos_drawer'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  
  return (
    <div className="pos-drawer-config">
      <div className="pos-drawer-config__row">
        <h4>POS Help</h4>
        <p>If the help URL is set, a 'Help' button will be shown on the POS main screen to access it.</p>
        <Input
          label="POS Help URL"
          onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_POS_HELP_URL')}
          value={props.config.DRAWER_POS_HELP_URL}
          disabled={!canEdit}
        />
      </div>
      <Divider/>
      <div className="pos-drawer-config__row" style={{marginBottom: 0}}>
        <div>
          <h4>Email Config</h4>
          <p>The following variables are supported on the email title and content:</p>
          <p><Tag color="orange">$CHARITY_NAME</Tag> the name of the charity that manages the location</p>
          <p><Tag color="orange">$LOCATION_NAME</Tag> the name of the location the drawer was closed</p>
          <p><Tag color="orange">$BUSINESS_DAY</Tag> business day the drawer was closed in MM/DD/YY</p>
        </div>
      </div>
      <Divider />
      <div className="pos-drawer-config__row" >
        <h4>General Email Config</h4>
        <Input
          label="Sender email (on the receiving end it's the email that will appear on the 'from')."
          onChange={(e: any) => props.setConfig(e.target.value, 'EMAIL_DRAWER_FEATURE_SENDER')}
          value={props.config.EMAIL_DRAWER_FEATURE_SENDER}
          disabled={!canEdit}
        />
      </div>
      <Divider />
      <div className="pos-drawer-config__row">
        <h4>Auto Close Drawer</h4>
        <p style={{marginBottom: 30}}>The email that is sent to a Charity when a location drawer is automatically closed by the system.</p>
        <Input
          label="Email title"
          onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_AUTOCLOSE_EMAIL_TITLE')}
          value={props.config.DRAWER_AUTOCLOSE_EMAIL_TITLE}
          disabled={!canEdit}
        />
        <div className="input-component">
          <div className="input-component__label">
            Email content
          </div>
          <div className="input-component__input">
            <TextArea
              rows={4}
              value={props.config.DRAWER_AUTOCLOSE_EMAIL_CONTENT}
              onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_AUTOCLOSE_EMAIL_CONTENT')}
              disabled={!canEdit}
            />
          </div>
        </div>
      </div>
      <Divider />
      <div className="pos-drawer-config__row">
        <h4>Charity notication when drawer net surpasses $2,000.00</h4>
        <p style={{marginBottom: 30}}>The email that is sent on EOB when a drawer is closed with more than $2,000.00.</p>
        <SwitchInput
          label="Enable sending email to charity."
          options={{ check: 'true', uncheck: 'false' }}
          onChange={(e) => props.setConfig(e, 'DRAWER_HIGH_CASH_WARNING_ENABLED')}
          value={props.config.DRAWER_HIGH_CASH_WARNING_ENABLED}
          disabled={!canEdit}
        />
        {props.config.DRAWER_HIGH_CASH_WARNING_ENABLED === 'true' && (
          <>
            <Input
              label="Email title"
              onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_HIGH_CASH_WARNING_EMAIL_TITLE')}
              value={props.config.DRAWER_HIGH_CASH_WARNING_EMAIL_TITLE}
              disabled={!canEdit}
            />
            <div className="input-component">
              <div className="input-component__label">
                Email content
              </div>
              <div className="input-component__input">
                <TextArea
                  rows={4}
                  value={props.config.DRAWER_HIGH_CASH_WARNING_EMAIL_CONTENT}
                  onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_HIGH_CASH_WARNING_EMAIL_CONTENT')}
                  disabled={!canEdit}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <Divider />
      <div className="pos-drawer-config__row">
        <h4>Charity notification on unredeemed credits</h4>
        <p style={{marginBottom: 30}}>The email is sent on EOB on the fifth day of the month that terminals had credits on them during EOB.  It is sent only once per month.</p>
        <SwitchInput
          label="Enable notification for unredeemed credits."
          options={{ check: 'true', uncheck: 'false' }}
          onChange={(e) => props.setConfig(e, 'DRAWER_UNREDEEMED_CREDIT_WARNING_ENABLED')}
          value={props.config.DRAWER_UNREDEEMED_CREDIT_WARNING_ENABLED}
          disabled={!canEdit}
        />
        {props.config.DRAWER_UNREDEEMED_CREDIT_WARNING_ENABLED === 'true' && (
          <>
            <Input
              label="Email title"
              onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_UNREDEEMED_CREDIT_WARNING_EMAIL_TITLE')}
              value={props.config.DRAWER_UNREDEEMED_CREDIT_WARNING_EMAIL_TITLE}
              disabled={!canEdit}
            />
            <div className="input-component">
              <div className="input-component__label">
                Email content
              </div>
              <div className="input-component__input">
                <TextArea
                  rows={4}
                  value={props.config.DRAWER_UNREDEEMED_CREDIT_WARNING_EMAIL_CONTENT}
                  onChange={(e: any) => props.setConfig(e.target.value, 'DRAWER_UNREDEEMED_CREDIT_WARNING_EMAIL_CONTENT')}
                  disabled={!canEdit}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default POSDrawer